<template>
  <div class="title">
    <div v-if="listType === 'block'"
         class="list-title block">
      {{ $t("alwaysBlock") | upperCase }}
      <div class="input-open-btn"
           @click="$emit('openInput')">
        <icon-cross width="16"
                    height="16"
                    color="#ffffff"
                    class="btn-plus" />
      </div>
    </div>
    <div v-if="listType === 'allow'"
         class="list-title allow">
      {{ $t("alwaysAllow") | upperCase }}
      <div class="input-open-btn"
           @click="$emit('openInput')">
        <icon-cross width="16"
                    height="16"
                    color="#ffffff"
                    class="btn-plus" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      listType: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 20px;

    .list-title {
      font-size: 14px;
      letter-spacing: 1px;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .input-open-btn {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 30px;
        height: 30px;
        cursor: pointer;

        font-size: 24px;
        background: map-get($colors, primary);
        border-radius: 50%;

        .btn-plus {
          transform: rotate(45deg);
        }
      }
    }

    .block {
      color: #f25b5b;
    }

    .allow {
      color: #16c47c;
    }
  }
</style>
